import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=b689d8c2&scoped=true&"
import script from "./CustomerForm.vue?vue&type=script&lang=js&"
export * from "./CustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerForm.vue?vue&type=style&index=1&id=b689d8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b689d8c2",
  null
  
)

export default component.exports